import { GtmData } from '@/types/writeup';
import { generateElement, generateMetaTag } from '@/common';

export function createGTMScript(gtmData: GtmData) {
	generateMetaTag('dealerID', gtmData.dealerId);
	generateMetaTag('providerID', gtmData.providerId);
	generateMetaTag('dwcp-seg', gtmData.siteSection);
	const headScriptData = `window.gtmDataLayer = window.gtmDataLayer || [];

	(function(w,d,s,l,i){
		w[l]=w[l]||[];
		w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
		var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=='dataLayer'?'&l='+l:'';
		j.async=true;
		j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
		f.parentNode.insertBefore(j,f);
		})(window,document,'script','gtmDataLayer','${gtmData.containerId}');

		function sendGoogleTagManagerData(dataLayer) {
			let eventData = dataLayer;

			if (window.gtmDataLayer && dataLayer) {
				if (!Array.isArray(eventData)) {
					eventData = [eventData];
				}

				eventData.forEach(layer => {
					window.gtmDataLayer.push(layer);
				});
			}
		}
		if (${JSON.stringify(gtmData.dataLayer.length)}) {
			sendGoogleTagManagerData(${JSON.stringify(gtmData.dataLayer)});
		}
		var gtmInitialViewEventFired = false;
		if (!gtmInitialViewEventFired && ${JSON.stringify(gtmData.eventsMapping)}) {
			sendGoogleTagManagerData(${JSON.stringify(gtmData.eventsMapping.initialView)});
		}
		gtmInitialViewEventFired = true;`;

	generateElement(headScriptData, 'dr-gtm-head-script', 'script', 'head');
	const bodyScriptData = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmData.containerId}"
		height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

	generateElement(bodyScriptData, 'dr-gtm-body-script', 'noscript', 'body');
}
